import {
  extendObservable,
  observable,
  action,
  reaction,
  autorun,
  computed,
  when,
} from "mobx";
import RequestHandler from "./RequestHandler";
import RequestStore from "./RequestStore";
import EsriBehaviour from "./DefaultBehaviours/EsriBehaviour";
import Request from "./Request";
import StandardBehaviour from "./DefaultBehaviours/StandardBehaviour";

class SingleRequestHandler {
  constructor(config) {
    this.config = config;
    this.history = []; // [{type: add,..},{delete..}]
    this.getFullConfig();
    RequestStore.requests[config.key].setValCompution(
      this.historyComputionCustom
        ? this.historyComputionCustom
        : this.historyCompution
    );
    RequestStore.requests[config.key].setState(this.initState);
  }

  getFullConfig() {
    const {
      key,
      server,
      fullUrl,
      proxyUrl,
      url,
      method,
      params = [],
      bodyParams,
      bodyType,
      offlineDownload,
      responseHandling,
      isError,
      errorMessage,
      synchroModus,
      autoRefresh,
      affecting,
      fixedParam,
      historyComputionCustom,
      validTime,
    } = this.config;
    this.RequestStore = RequestStore;
    if (server) {
      this.server = RequestStore.requestHandler.server[server];
    }
    const cascadeingConfigFields = [
      "instantParameterRefreshState",
      "defaultBehaviour",
      "instantParameterRefresh",
      "validTime",
      "proxyUrl",
      "method",
      "bodyType",
      "isError",
      "errorMessage",
      "synchoModus",
      "autoRefresh",
      "affecting",
      "historyComputionCustom",
      "unvalidState",
      "initState",
      "onDemandRequest",
      "params",
    ];
    const notCascadeingConfigFields = [
      "fullUrl",
      "url",
      "offlineDownload",
      "key",
      "serverName",
      "fixedParam",
    ];
    notCascadeingConfigFields.forEach(
      (field) => (this[field] = this.config[field])
    );
    // this.params = params;
    cascadeingConfigFields.forEach((field) => this.cascadeConfig(field));
    this.prepareConfig();
    this.setUpReactionParams();
    this.setUpReactionState();

    // this.proxyUrl = proxyUrl?proxyUrl:this.server && this.server.proxyUrl?this.server.proxyUrl:RequestStore.requestHandler.proxyUrl;
  }

  prepareConfig() {
    this.builtUrl = this.fullUrl
      ? this.fullUrl
      : this.server
        ? this.server.serverUrl + this.url
        : RequestStore.requestHandler.baseUrl + this.url;
    // this.defaultBehaviour = this.defaultBehaviour?this.defaultBehaviour:this.server && this.server.defaultBehaviour?this.server.defaultBehaviour:RequestStore.requestHandler.defaultBehaviour;
    const functions = ["responseHandling", "isError", "errorMessage"];
    functions.forEach((f) => this.setUpFunction(f));
  }

  setUpFunction(name) {
    this[name] = this.config[name];
    if (!this.getDefaultBehaviour(name)) {
      // if(!this.server || this.getDefaultBehaviour(this.server,name)){
      //     if(!this.getDefaultBehaviour(RequestStore.requestHandler,name)){
      // console.log("Something wrong with the Functions");
      //     }
      // }
    }
  }

  getDefaultBehaviour(name) {
    // to do: path function, default functions (i.e. default errorFunctionm => response state dingsel)
    if (this[name]) {
      if (typeof this[name] === "function") {
        this[`${name}Function`] = this[name];
        return true;
      }
      if (typeof this[name] === "string") {
        // TODO: PATH!
        this.getDefaultBehaviourFunction(name, this[name]);
        return true;
      }
    } else if (this.server !== undefined && this.server[name] !== undefined) {
      this[name] = this.server[name];
      this.getDefaultBehaviour(name);
    } else if (this.defaultBehaviour) {
      this.getDefaultBehaviourFunction(name, this.defaultBehaviour);
      return true;
    }
    return false;
  }

  getDefaultBehaviourFunction(funName, defaultName) {
    switch (defaultName) {
      case "esri":
        this[`${funName}Function`] = EsriBehaviour[funName];
        break;
      case "none":
        this[`${funName}Function`] = StandardBehaviour[funName];
        break;
      default:
        this[`${funName}Function`] = StandardBehaviour[funName];
    }
  }

  cascadeConfig(confAttr) {
    this[confAttr] =
      this.config[confAttr] !== undefined
        ? this.config[confAttr]
        : typeof this.server !== typeof undefined &&
          this.server[confAttr] !== undefined
          ? this.server[confAttr]
          : RequestStore.requestHandler[confAttr];
  }

  historyCompution(value, history) {
    if (Array.isArray(value)) {
      const computedVal = value;
      for (let i = 0; i < history.length; i++) {
        const histc = history[i];
        switch (histc.type) {
          case "delete":
          case "new":
          case "update":
        }
      }
      return computedVal;
    }
    if (history.length > 0) {
      return history[history.length - 1];
    }
    return value;
  }

  addToHistory(request) {
    this.history.push(request);
  }

  clearHistory() {
    this.history = [];
  }

  setUpReactionParams() {
    if (RequestStore.parameterStore) {
      const params = this.params;
      const notFixedParams = this.fixedParam
        ? params.filter(
          (p) =>
            !this.fixedParam ||
            (!this.fixedParam[p.get] && !this.fixedParam[p.reqGet])
        )
        : params; // fixedParameter Ausklammern
      notFixedParams.forEach((p) => {
        if (
          (this.instantParameterRefresh &&
            typeof p.instantRefresh === typeof undefined) ||
          p.instantRefresh
        ) {
          if (typeof p.get !== typeof undefined) {
            when(
              () =>
                typeof RequestStore.parameterStore.parameters[p.get] !==
                typeof undefined,
              () =>
                reaction(
                  () => RequestStore.parameterStore.parameters[p.get].value,
                  () => {
                    RequestStore.requests[this.key].setState(
                      this.instantParameterRefreshState
                    );
                  }
                )
            );
          }
          if (typeof p.reqGet !== typeof undefined) {
            when(
              () => typeof RequestStore.requests[p.reqGet] !== typeof undefined,
              () =>
                reaction(
                  () => RequestStore.requests[p.reqGet].value,
                  () => {
                    RequestStore.requests[this.key].setState(
                      this.instantParameterRefreshState
                    );
                  }
                )
            );
            // reaction(()=> RequestStore.requests[p.reqGet].value, ()=>{RequestStore.requests[this.key].setState(this.instantParameterRefreshState)})
          }
        }
      });
      if (this.instantParameterRefresh) {
        this.getInlineParameterKeys().forEach((key) => {
          if (!this.fixedParam || !this.fixedParam[key]) {
            when(
              () =>
                typeof RequestStore.parameterStore.parameters[key] !==
                typeof undefined,
              () =>
                reaction(
                  () => RequestStore.parameterStore.parameters[key].value,
                  () => {
                    RequestStore.requests[this.key].setState(
                      this.instantParameterRefreshState
                    );
                  }
                )
            );
          }
        });
        this.getInlineReqParameterKeys().forEach((key) => {
          if (!this.fixedParam || !this.fixedParam[key]) {
            when(
              () => typeof RequestStore.requests[key] !== typeof undefined, // wenn der Store voirhanden ist erst reaction setzen
              () =>
                reaction(
                  () => RequestStore.requests[key].value, // wenn der store wert sich ändert
                  () => {
                    RequestStore.requests[this.key].setState(
                      this.instantParameterRefreshState
                    );
                  }
                )
            ); // dann setze den state hier auch entsprechend um
          }
        });
      }
    }
  }

  getInlineParameter() {
    const url = this.builtUrl;
    if (url.includes("/") && url.includes("{")) {
      const regexp = /{([^}]*)}/g;
      const parts = [...url.matchAll(regexp)].map(([fullMatch, param]) => {
        return param;
      });
      return parts;
    }
    return [];
  }

  getInlineReqParameterKeys() {
    const keys = this.getInlineParameter();
    const annoKeys = keys.filter((key) => key.includes(":"));
    const reqAnnoKeys = annoKeys.filter((key) =>
      key.split(":")[0].startsWith("req")
    );
    return reqAnnoKeys.map((key) => key.split(":")[1]);
  }

  getInlineParameterKeys() {
    const keys = this.getInlineParameter();
    const normalKeys = keys.filter((key) => !key.includes(":")); // nicht annotierte Schlüssel
    const annoKeys = keys.filter((key) => key.includes(":")); // Annotierte ParameterSchlüssel
    const notReqAnnoKeys = annoKeys.filter(
      (key) => !key.split(":")[0].startsWith("req")
    ); // nicht mit "req:" annotiert
    return normalKeys.concat(notReqAnnoKeys.map((key) => key.split(":")[1])); // zusammem
  }

  setUpReactionState() {
    autorun(() => {
      this.refresh(RequestStore.requests[this.key].state);
    });
  }

  getParameterValues() {
    const parameter = [];
    const inlineParameterKeys = this.getInlineParameterKeys();
    this.params
      .filter(
        (p) =>
          !inlineParameterKeys.includes(p.get) &&
          !inlineParameterKeys.includes(p.reqGet)
      )
      .forEach((p) => {
        const {
          get,
          reqGet,
          type,
          transform = (o) => o,
          to = get || reqGet,
        } = p;
        let val;
        if (reqGet) {
          // keys aus anderen Requests
          if (this.fixedParam && this.fixedParam[reqGet]) {
            val = this.fixedParam[reqGet];
          } else {
            val = RequestStore.requests[reqGet].value;
          }
        } else {
          // key aus externen store
          if (this.fixedParam && this.fixedParam[get]) {
            // fixed Parameter übernehmen wenn da
            val = this.fixedParam[get];
          } else {
            val = RequestStore.parameterStore.parameters[get].value;
          }
        }
        parameter.push({
          key: to,
          value: transform(val), // tlw muss hier statt der value ein objekt stehen mit z.b. {"PS_bkBetriebsteil": 123}
          type,
        });
      });
    return parameter;
  }

  refresh(state) {
    switch (state) {
      case "toRequest":
        this.setUpRequest();
        break;
      case "error":
      case "success":
        if (typeof this.validTime !== typeof undefined) {
          // bspw für wiederabfrage des tokens nach x minuten
          setTimeout(() => {
            if (this.RequestStore.requests[this.key].state === "success") {
              this.RequestStore.requests[this.key].setState(
                this.unvalidState ? this.unvalidState : "toRequest"
              );
            }
          }, this.validTime);
        }
        if (this.affecting) {
          // affected requests sollen standardmäßig neu geladen werden (eventuell hier die möglichkeit einbinden, die nich neu zu laden, sondern auf einen anderen state, bspw nothing zu setzen, damit sie on demand geladen werden?)
          this.affecting.forEach((aff) =>
            RequestStore.requestHandler.getMatchingKeys(aff).forEach(
              (
                affSpec // getMatchingKeys: auch wenn affecting:[btt] steht, werden btt/123 sachen affected!
              ) => RequestStore.requests[affSpec].setState("toRequest")
            )
          );
        }
      default:
    }
  }

  getParameterizedUrl(url) {
    // todo: errorcatching => params not (yet) in stores, for example benutzerID in paramstore
    let parameterizedUrl = url;
    if (url.includes("/") && url.includes("{")) {
      // slashes und {} => es gibt parameter in der url inline
      const regexp = /{([^}]*)}/g;
      const parts = [...parameterizedUrl.matchAll(regexp)].map(
        ([fullMatch, param]) => {
          return param;
        }
      ); // gibt genau die ausdrücke in /{ }/ wieder (bei letztem evenntuell flasch?)
      // const firstPart = parameterizedUrl.split("/{")[0] // erster part der url, ohne obige ausdrpcke

      const getTransformFun = (key) => {
        let transform = (obj) => obj;
        this.config.params
          .filter((p) => p.reqGet == key && p.transform !== undefined)
          .forEach((p) => {
            transform = p.transform;
          });
        this.config.params
          .filter((p) => p.get == key && p.transform !== undefined)
          .forEach((p) => {
            transform = p.transform;
          });
        return transform;
      };
      parameterizedUrl = url;
      parts.forEach((part) => {
        // url wird hier neu zusammengebaut, vmtl wäre suchen und ersetzten der entsprechenden stellen besser, falls in der url dazwischen noch dinge vorkommen wie {btt}/0/{art}
        if (part.includes(":")) {
          // besitzt annotation aus welchem store der param kommt
          const pps = part.split(":");
          const type = pps[0];
          if (this.fixedParam && this.fixedParam[pps[1]])
            // ist aber schon durch fixedparameter gesetetzt (bswp bestaende/123 für bestaende/{btt})
            parameterizedUrl = parameterizedUrl.replace(
              `{${part}}`,
              getTransformFun(pps[1])(this.fixedParam[pps[1]])
            );
          // parameterizedUrl + "/" + this.fixedParam[pps[1]];
          else if (type.startsWith("req")) {
            parameterizedUrl = parameterizedUrl.replace(
              `{${part}}`,
              getTransformFun(pps[1])(RequestStore.requests[pps[1]].value)
            ); // parameterizedUrl + "/" + RequestStore.requests[pps[1]].value; //ist nicht durch fixedparameter gesetzt, kommt aus einem Request (bspw token, foerster)
          } else {
            parameterizedUrl = parameterizedUrl.replace(
              `{${part}}`,
              getTransformFun(pps[1])(
                RequestStore.parameterStore.parameters[pps[1]].value
              )
            ); // parameterizedUrl + "/" + RequestStore.parameterStore.parameters[pps[1]].value; //ist nicht durch fixedparameter gesetzt, kommt aus parameter store von aupen (bspw abfrageart?)
          }
        }
        if (this.fixedParam && this.fixedParam[part]) {
          parameterizedUrl = parameterizedUrl.replace(
            `{${part}}`,
            getTransformFun(part)(this.fixedParam[part])
          ); // parameterizedUrl + "/" + this.fixedParam[part]; //fixedparameter ist gesetzt, aber keine annotation im parameter dingen (also kein {req:xyz} sondern {xyz})
        } else {
          parameterizedUrl = parameterizedUrl.replace(
            `{${part}}`,
            getTransformFun(part)(
              RequestStore.parameterStore.parameters[part].value
            )
          ); // parameterizedUrl + "/" + RequestStore.parameterStore.parameters[part].value; //fixedparameter ist nicht vorhanden, keine annotation gesetzt => standard aus parameterstore
        }
      });
    }
    return parameterizedUrl;
  }

  setUpRequest() {
    const readyParams = this.getParameterValues();
    RequestStore.requests[this.key].setState("loading");
    const reqConf = {
      key: this.key,
      url: this.getParameterizedUrl(this.builtUrl),
      method: this.method,
      getParams: readyParams.filter((p) => p.type && p.type === "get"),
      postParams: readyParams.filter((p) => !p.type || p.type !== "get"),
      bodyType: this.bodyType,
      responseHandlingFunction: this.responseHandlingFunction,
      isErrorFunction: this.isErrorFunction,
      errorMessageFunction: this.errorMessageFunction,
      useCheckedOut: false, // TODO
    };
    if (false && this.affecting && this.affecting.length > 0) {
      Request.storeRequest(reqConf);
      this.affecting.forEach((aff) =>
        RequestStore.requestHandler.getMatchingKeys(aff).forEach(
          (
            affSpec // getMatchingKeys: auch wenn affecting:[btt] steht, werden btt/123 sachen affected!
          ) =>
            RequestStore.requests[affSpec].addToHistory({
              type: this.offline.type,
              key: this.key,
              params: this.readyParams,
            })
        )
      );
      RequestStore.requests[this.key].setState("success");
    }
    Request.handleRequest(reqConf)
      .then((val) => {
        RequestStore.requests[this.key].setValue(val); // wenn checkedout && affecting
        RequestStore.requests[this.key].setState("success");
      })
      .catch((error) => {
        RequestStore.requests[this.key].setMessage(error);
        RequestStore.requests[this.key].setState("error");
      });
  }

  getStoredRequests() {
    const configs = Request.getRequests(this.key);
    return configs.map(({ timestamp, url, getParams, postParams }) => {
      return {
        key: this.key,
        timestamp,
        url,
        proxyUrl: this.proxyUrl,
        method: this.method,
        getParams,
        postParams,
        bodyType: this.bodyType,
        responseHandlingFunction: this.responseHandlingFunction,
        isErrorFunction: this.isErrorFunction,
        errorMessageFunction: this.errorMessageFunction,
        useCheckedOut: false, // TODO
      };
    });
  }

  // upload(){
  //     const configs = Request.getRequests(this.key);
  //     configs.sort();
  //     configs.forEach(c=>{
  //         const {
  //             timespam,
  //             url,
  //             getParams,
  //             postParams
  //         }  = c;
  //         const reqConf = {
  //             key:this.key,
  //             url:url,
  //             method:this.method,
  //             getParams: getParams,
  //             postParams: postParams,
  //             bodyType: this.bodyType,
  //             responseHandlingFunction: this.responseHandlingFunction,
  //             isErrorFunction:this.isErrorFunction,
  //             errorMessageFunction:this.errorMessageFunction,
  //             useCheckedOut:false //TODO
  //         };

  //     })
  // }
  // handleRequest(fullUrl, method, readyParams, bodyParams, bodyType, useCheckedOut ){
  //     // if(!useCheckedOut){

  //     // }
  //     // else{
  //     //     //
  //     //     // if(this.affecting && this.config.offline){
  //     //     //     const hist = this.config.offline;
  //     //     //     hist.data = readyParams;
  //     //     //     this.affecting.forEach(aff=> RequestStore.requests[aff].addToHistory(hist))
  //     //     // }
  //     // }
  // }

  // handleResponse(response){
  //     if(!RequestHandler.useCheckedOut){
  //         if(this.isErrorFunction(response)){
  //             RequestStore.requests[this.key].setMessage(this.errorMessageFunction(response))
  //             RequestStore.requests[this.key].setState("error");
  //         }
  //         else{
  //             RequestStore.requests[this.key].setValue(this.responseHandlingFunction(response))
  //             RequestStore.requests[this.key].setState("success");
  //         }
  //     }
  // }
}

export default SingleRequestHandler;
